import { render, staticRenderFns } from "./SkribblePopup.vue?vue&type=template&id=ac13250c&scoped=true&"
import script from "./SkribblePopup.vue?vue&type=script&lang=js&"
export * from "./SkribblePopup.vue?vue&type=script&lang=js&"
import style0 from "./SkribblePopup.vue?vue&type=style&index=0&id=ac13250c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac13250c",
  null
  
)

export default component.exports